export default __webpack_public_path__ + "static/media/laforge-and-glasius.4c2cefb9.jpg";